var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h3", [_vm._v(_vm._s(_vm.enviarCorreoText))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card__content" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-xs-12" }, [
            _c(
              "div",
              { staticClass: "form-field" },
              [
                _c(
                  "input-field",
                  {
                    attrs: {
                      id: "correosCliente",
                      placeholder: _vm.$t("message.placeholderCorreo")
                    },
                    model: {
                      value: _vm.form.correos,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "correos", $$v)
                      },
                      expression: "form.correos"
                    }
                  },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.$t("message.email")) +
                        "\n                            "
                    ),
                    _vm.errores.correos
                      ? _c(
                          "span",
                          {
                            staticClass: "helper-text text-danger",
                            attrs: { slot: "helper" },
                            slot: "helper"
                          },
                          [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.errores.correos[0]))
                            ])
                          ]
                        )
                      : _vm._e()
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form-field select" }, [
              _c("div", { staticClass: "select-field" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.tipo,
                        expression: "form.tipo"
                      }
                    ],
                    attrs: { name: "tipo", id: "tipo" },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.form,
                          "tipo",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { value: "in" } }, [_vm._v("IN")]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "out" } }, [_vm._v("OUT")])
                  ]
                ),
                _vm._v(" "),
                _c("label", { attrs: { for: "tipo" } }, [_vm._v("Tipo de EIR")])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-field select" }, [
              _c("div", { staticClass: "select-field" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.proceso,
                        expression: "form.proceso"
                      }
                    ],
                    attrs: { name: "proceso", id: "proceso" },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.form,
                          "proceso",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { value: "C" } }, [_vm._v("Caja")]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "M" } }, [_vm._v("Máquina")])
                  ]
                ),
                _vm._v(" "),
                _c("label", { attrs: { for: "proceso" } }, [_vm._v("Proceso")])
              ])
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-buttons" }, [
      _c(
        "button",
        {
          staticClass: "btn-success",
          attrs: { type: "button" },
          on: { click: _vm.enviarCorreo }
        },
        [
          _c("i", { staticClass: "fa fa-envelope" }),
          _c("span", [_vm._v(_vm._s(_vm.$t("message.enviarCorreo")))])
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "btn-danger btn--text", on: { click: _vm.cancelar } },
        [
          _c("i", { staticClass: "fa fa-ban" }),
          _c("span", [_vm._v(_vm._s(_vm.$t("message.cancelar")))])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c85c657c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c85c657c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/clientes/EnviarEir.vue
// module id = 319
// module chunks = 0